import React from "react";
import { transitions, positions, Provider as AlertProvider } from "react-alert";
import AlertTemplate from "react-alert-template-basic";

const options = {
  position: positions.BOTTOM_RIGHT,
  timeout: 3000,
  offset: "15px",
  transition: transitions.FADE,
};

const AlertMessage = ({ children }) => (
  <AlertProvider template={AlertTemplate} {...options}>
    {children}
  </AlertProvider>
);

export default AlertMessage;
